// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles-m__heading__K9NZH","collection-heading":"styles-m__collection-heading__26H13"};